import axios from 'axios';

// axios instance for making requests 
const axiosInstance = axios.create();

// request interceptor for adding token
axiosInstance.interceptors.request.use((config) => {
  config.baseURL = import.meta.env.VITE_API_BASE_URL
  return config;
});

export default axiosInstance;